module.exports = __webpack_public_path__ + "f61292a2d4bb19f4659b85f3d9998535.png";


//////////////////
// WEBPACK FOOTER
// ../images/icons/lightbulb.png
// module id = 1261
// module chunks = 69